"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar;

  return {
    root: function root(spacing) {
      return {
        "& .mco-gallery-03__grid": {
          display: "flex",
          marginLeft: "-".concat(spacing, "px"),
          width: "auto"
        },
        "& .mco-gallery-03__column": {
          paddingLeft: spacing,
          backgroundClip: "padding-box"
        },
        "& .mco-gallery-03__column > div": {
          aspectRatio: "3 / 4",
          cursor: "pointer",
          marginBottom: spacing,
          position: "relative"
        },
        "& .mco-gallery-03__column:first-child > div:nth-child(3n + 1)": {
          aspectRatio: "1 / 1"
        },
        "& .mco-gallery-03__column:first-child > div:nth-child(3n + 2)": {
          aspectRatio: "4 / 3"
        },
        "& .mco-gallery-03__column:nth-child(2) > div:nth-child(3n + 2)": {
          aspectRatio: "1 / 1"
        },
        "& .mco-gallery-03__column:nth-child(2) > div:nth-child(3n + 3)": {
          aspectRatio: "4 / 3"
        },
        "& .mco-gallery-03__column:last-child > div:nth-child(3n + 1)": {
          aspectRatio: "4 / 3"
        },
        "& .mco-gallery-03__column:last-child > div:nth-child(3n + 2)": {
          aspectRatio: "1 / 1"
        }
      };
    },
    thumbItem: {
      cursor: "pointer",
      width: 40 + "px !important",
      "&.swiper-slide-thumb-active": {
        outline: "3px solid " + (theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main)
      }
    },
    skeleton: {
      height: "100% !important",
      position: "absolute",
      width: "100%"
    },
    button: {
      display: "table",
      margin: "32px auto 0"
    }
  };
});
var _default = styles;
exports.default = _default;